import React, { useEffect, useState } from "react";
import "./CtaCorrienteList.css";
import moment from "moment";

const CtaCorrienteList = ({ fchdes, fchhas, orderBy, order, list }) => {
  const [totales, setTotales] = useState({});

  /*     const list = [
        {fecha:'2024-01-01',TIPFOR:'Saldo Inicial',NROFOR:'0002-00003082',NROINT:528000139,Debe:0.00,Haber:1548800.01,saldo:0},
        {fecha:'2024-01-03',TIPFOR:'Factura Proveedor',NROFOR:'',NROINT:72452,Debe:953343.41,Haber:0,saldo:0},
        {fecha:'2024-01-05',TIPFOR:'Orden de Pago a Prov.',NROFOR:'',NROINT:11204,Debe:14656.60,Haber:0,saldo:0},
        {fecha:'2024-01-05',TIPFOR:'Reten Impuestos a las Ganancias',NROFOR:'',NROINT:72852,Debe:1524543.41,Haber:0,saldo:0},
        {fecha:'2024-02-02',TIPFOR:'Factura Proveedor',NROFOR:'0002-00003105',NROINT:529000113,Debe:0,Haber:2238500.01,saldo:0},
        {fecha:'2024-02-02',TIPFOR:'Factura Proveedor',NROFOR:'0002-00003117',NROINT:529000325,Debe:0,Haber:224243.25,saldo:0},
        {fecha:'2024-02-07',TIPFOR:'Factura Proveedor',NROFOR:'0002-00003121',NROINT:530000136,Debe:0,Haber:226657.20,saldo:0},
        {fecha:'2024-02-21',TIPFOR:'Factura Proveedor',NROFOR:'0002-00003132',NROINT:530000137,Debe:0,Haber:1937512.51,saldo:0},
        {fecha:'2024-03-07',TIPFOR:'Reten Impuestos a las Ganancias',NROFOR:'',NROINT:72852,Debe:1524543.41,Haber:0,saldo:0},
    ]; */
  const [listFiltered, setListFiltered] = useState(list);

  const formatter = new Intl.NumberFormat("en-US");

  const calculateTotals = () => {
    let saldoInicial = 0;
    let importe = 0;
    let newList = [...list];
    let newListFiltered = newList.filter((ctaCorriente) => {
      return (
        new Date(ctaCorriente.fchMov).getTime() >= new Date(fchdes).getTime() &&
        new Date(ctaCorriente.fchMov).getTime() <= new Date(fchhas).getTime()
      );
    });

    switch (orderBy) {
      case "Fecha":
        newListFiltered.sort((a, b) =>
          order === "asc"
            ? a.fchMov.localeCompare(b.fchMov)
            : b.fchMov.localeCompare(a.fchMov)
        );
        break;

      case "Titulo":
        newListFiltered.sort((a, b) =>
          order === "asc"
            ? a.formDescrp.localeCompare(b.formDescrp)
            : b.formDescrp.localeCompare(a.formDescrp)
        );
        break;

      default:
        break;
    }

    newList.map((ctaCorriente, i) => {
      const fechaMov = ctaCorriente.fchMov.split("T")[0];
      const fechaDesde = fchdes.split("T")[0];
      const fechaHasta = fchhas.split("T")[0];

      if (fechaMov < fechaDesde) {
        saldoInicial = saldoInicial + ctaCorriente.impNac;
      }

      if (fechaMov >= fechaDesde && fechaMov <= fechaHasta) {
        importe = importe + ctaCorriente.impNac;
      }
    });

    newListFiltered.forEach((ctaCorriente) => {
      console.log(ctaCorriente);
      /*Quizas sirva si se agregan items dinamicamente, hasta definirlo no borrar
            setTotales((prevTotales)=>{
                let newTotales = prevTotales;
                newTotales.debe += ctaCorriente.Debe;
                newTotales.haber += ctaCorriente.Haber;
                return newTotales; 
            })*/
    });
    let newTotales = {
      saldoInicial: saldoInicial,
      importe: importe,
      saldoFinal: (saldoInicial + importe),
    };
    setTotales(newTotales);
    setListFiltered(newListFiltered);
  };

  useEffect(() => {
    calculateTotals();
  }, [fchdes, fchhas, orderBy, order, list]);

  return (
    <div className="ctaCorrienteListDiv">
      <div className="listHeader">
        <h4>Fecha</h4>
        <h4>Tipo de Comprobante</h4>
        <h4>N° Comprob</h4>
        <h4>N° Interno</h4>
        <h4>Importe</h4>
      </div>
      <div className="listBody">
        {listFiltered.map((ctaCorriente, i) => (
          <div key={i} className="itemList">
            <h5>{moment(ctaCorriente.fchMov).format("DD-MM-YYYY")}</h5>
            <h5 id="listTipoComprobante">{ctaCorriente.formDescrp}</h5>
            <h5>{ctaCorriente.codOri}</h5>
            <h5>{ctaCorriente.nroFor}</h5>
            <h5>${formatter.format(ctaCorriente.impNac)}</h5>
          </div>
        ))}
      </div>
      <div className="totalesDiv">
        <h4 className="subtotalItem" id="subtotalLabel">
          Totales:
        </h4>

        <div className="subtotalItem" id="subtotalSaldoInicial">
          <small>Saldo Inicial:</small>
          <div>${formatter.format(totales.saldoInicial)}</div>
        </div>

        <div className="subtotalItem" id="subtotalImporte">
          <small>Importe:</small>
          <div>${formatter.format(totales.importe)}</div>
        </div>

        <div className="subtotalItem" id="subtotalSaldoFinal">
          <small>Saldo Final:</small>
          <div>${formatter.format(totales.saldoFinal)}</div>
        </div>
      </div>
    </div>
  );
};

export default CtaCorrienteList;